import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { inject, observer, PropTypes as mobxPropTypes } from 'mobx-react';
import { Paper } from '@material-ui/core';
import UserForm from '../../containers/UserForm/UserForm';

const styles = theme => ({
  paper: {
    padding: theme.spacing.unit * 3,
    marginTop: theme.spacing.unit,
  },
});

const propTypes = {
  classes: PropTypes.oneOfType([PropTypes.object]).isRequired,
  userStore: mobxPropTypes.observableObject.isRequired,
  snackbarStore: mobxPropTypes.observableObject.isRequired,
  history: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

const UserAddPage = ({
  classes,
  userStore,
  snackbarStore,
  history,
}) => {
  const handleSubmit = async (values, setSubmitting) => {
    try {
      await userStore.api.users.create(values);

      snackbarStore.setSuccess({
        title: 'User has been successfully created.',
      });

      history.push('/users');
    } catch (error) {
      setSubmitting(false);
      snackbarStore.setError({
        title: `Sorry, an error occurred.${error.errors ? ' Please correct the errors below:' : ''}`,
        duration: null,
        messages: error.errors ? error.errors : null,
      });
    }
  };

  return (
    <div>
      <Paper className={classes.paper}>
        <UserForm onSubmit={handleSubmit} />
      </Paper>
    </div>
  );
};

UserAddPage.propTypes = propTypes;
const UserAddPageStyled = withStyles(styles, { withTheme: true })(UserAddPage);
export default inject('userStore', 'snackbarStore')(observer(UserAddPageStyled));



// WEBPACK FOOTER //
// ./src/pages/Users/Add.js